import { SettlementStateTag } from "@/components/partners";
import { Alert } from "@msuite/ui/alert";
import { useTranslation } from "@msuite/ui/localization";
import type { SettlementRecordState } from "@msuite/utils/partnerships";
import { getAddressString } from "@msuite/utils/strings";
import type { Nullable, Tables } from "@msuite/utils/types";

/** Props Interface */
interface AssignmentReferenceBookingsHeaderProps {
	project: Nullable<Tables<"projects">>;
	tickets: Nullable<Tables<"tickets">[]>;
	state: SettlementRecordState;
}

export function AssignmentReferenceBookingsHeader({
	project,
	state,
}: AssignmentReferenceBookingsHeaderProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="py-4 border-color border-b-[0.5px] modal-padding v-stack">
			{/* The name and the address stand as one block, so the tag beside them — taller than a
			line of text — centres on the pair instead of pushing the address down. */}
			<div className="justify-between h-stack">
				<div className="gap-0 min-w-0 v-stack">
					<p className="font-semibold">{project?.name}</p>
					<p>{getAddressString(project)}</p>
				</div>
				<div className="h-stack">
					<p>{project?.number}</p>
					<SettlementStateTag state={state} />
				</div>
			</div>
			{state === "approved" && (
				<Alert
					variant="success"
					title={t("general.approved")}
					description={t("partners.approved_reference_hint")}
				/>
			)}
		</div>
	);
}
